import NetworkField from "@/components/marketing/NetworkField";

const DRIFT = `
@keyframes abDriftA{0%,100%{transform:translate3d(0,0,0) scale(1)}50%{transform:translate3d(8vw,6vh,0) scale(1.12)}}
@keyframes abDriftB{0%,100%{transform:translate3d(0,0,0) scale(1.06)}50%{transform:translate3d(-7vw,-5vh,0) scale(1)}}
.ab-drift{will-change:transform;animation-timing-function:cubic-bezier(0.45,0,0.25,1);animation-iteration-count:infinite}
@media (prefers-reduced-motion: reduce){.ab-drift{animation:none!important}}
`;

// Page-wide themed backdrop — rich static glows with GPU-cheap opacity "breathing" + a faint dot grid.
// `living` adds the ARI-conversation ambience page-wide: slow roaming champagne light and one
// fixed, depth-projected network (a single canvas, paused when hidden).
export const AmbientBackground = ({ living = false }) => (
  <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true" data-testid={living ? "ambient-living" : undefined}>
    <div className="aurora breathe w-[560px] h-[560px] bg-[#D4AF37]/[0.10]" style={{ top: "-14%", right: "-10%" }} />
    <div className="aurora breathe w-[500px] h-[500px] bg-[#B87333]/[0.09]" style={{ top: "42%", left: "-16%", animationDelay: "-3.5s" }} />
    <div className="aurora breathe w-[520px] h-[520px] bg-[#D4AF37]/[0.07]" style={{ top: "92%", right: "-8%", animationDelay: "-6.5s" }} />
    <div className="absolute inset-0 opacity-[0.10]"
      style={{ backgroundImage: "radial-gradient(rgba(212,175,55,0.16) 1px, transparent 1px)", backgroundSize: "30px 30px" }} />
    {living && (
      <>
        <style>{DRIFT}</style>
        <div className="ab-drift absolute rounded-full" style={{ left: "-10%", top: "8%", width: "60vw", height: "60vw", filter: "blur(40px)", background: "radial-gradient(closest-side, rgba(150,120,46,0.12), transparent 72%)", animationName: "abDriftA", animationDuration: "38s" }} />
        <div className="ab-drift absolute rounded-full" style={{ right: "-14%", top: "40%", width: "56vw", height: "56vw", filter: "blur(44px)", background: "radial-gradient(closest-side, rgba(176,144,74,0.08), transparent 70%)", animationName: "abDriftB", animationDuration: "46s" }} />
        <NetworkField count={22} speed={0.12} linkDist={0.22} style={{ opacity: 0.55 }} />
      </>
    )}
  </div>
);
